import * as React from 'react';

import { TableCell } from '../components/ui/table.js';

export function DimeTableCell({ ...props }: Readonly<React.ComponentProps<typeof TableCell>>) {
  return <TableCell {...props} />;
}
